














































import { Watch, Prop, Component, Vue, Ref } from 'vue-property-decorator'
import { ProviderInstance } from 'vee-validate/dist/types/types'
import { isEqual } from 'lodash'

export interface SelectOption {
    label: string,
    value: string,
}

@Component
export default class InputMultiSelect extends Vue {
    @Ref() validator!: ProviderInstance
    @Prop({ default: null }) readonly rules!: string
    @Prop({ default: 'filters actief' }) readonly suffix!: string
    @Prop() readonly selectedTranslationKey!: string
    @Prop() readonly allSelectedTranslationKey!: string
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop({ required: true }) readonly options!: SelectOption[]
    @Prop() readonly value!: any[]
    @Prop({ type: Boolean, default: false }) readonly disabled: boolean
    @Prop({ type: Boolean, default: false }) readonly clearable!: boolean
    @Prop({ type: Boolean, default: false }) readonly white!: boolean
    selected: any[] = []
    showOptions: boolean = false
    prevSelected: any[] = []

    created() {
        this.onValueChanged()
        window.addEventListener('click', this.onOutsideClick)
    }

    beforeDestroy() {
        window.removeEventListener('click', this.onOutsideClick)
    }

    @Watch('options')
    onOptionsChanged() {
        this.selected = this.selected.filter(value => {
            return this.options.some((option: SelectOption) => option.value === value)
        })
        this.onSelectedChanged()
    }

    @Watch('value')
    onValueChanged() {
        this.selected = []

        if (!this.value) {
            return
        }

        this.value.forEach(v => {
            const option = this.findOptionByValue(v)
            if (option && this.selected.some(s => s === option.value) === false) {
                this.selected.push(option.value)
            }
        })

        this.onSelectedChanged()
    }

    onSelectedChanged() {
        if (isEqual(this.prevSelected, this.selected)) {
            return
        }

        this.validator?.validate(this.selected)
        this.$emit('input', this.selected)
        this.prevSelected = this.selected
    }

    toggleOptions(): void {
        if (!this.disabled) {
            this.showOptions = !this.showOptions
        }
    }

    toggleOption(optionValue: string) {
        if (this.disabled) {
            return
        }

        if (this.isSelected(optionValue)) {
            this.selected = this.selected.filter(value => value !== optionValue)
        } else {
            this.selected.push(optionValue)
        }

        this.onSelectedChanged()
    }

    isSelected(optionValue: string) {
        return this.selected.includes(optionValue)
    }

    findOptionByValue(value: string) {
        const options = this.options.filter(option => option.value === value)
        if (options.length > 0) {
            return options[0]
        }

        return null
    }

    get isClearable(): boolean {
        return this.clearable && this.selected.length && !this.disabled
    }

    clear(): void {
        this.selected = []
        this.onSelectedChanged()
        this.showOptions = false
    }

    get componentClass(): object {
        return {
            'input-multi-select': true,
            'input-select': true,
            'input-select--disabled': this.disabled,
            'input-select--white': this.white,
        }
    }

    async onOutsideClick(e: Event) {
        const target = e.target as HTMLDivElement

        if (!this.$el.contains(target)) {
            this.showOptions = false
        }
    }
}
